import { render } from "./DataViewer.vue?vue&type=template&id=e478006e"
import script from "./DataViewer.vue?vue&type=script&lang=ts"
export * from "./DataViewer.vue?vue&type=script&lang=ts"

import "./DataViewer.vue?vue&type=style&index=0&id=e478006e&lang=scss"
script.render = render

export default script